import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import EditableTable from './EditableTable';
import {resource} from '../utils/request';

const mapDispatchToProps = (dispatch, ownProps) => {
  const restfulResource = resource(ownProps.basePath);

  const index = restfulResource.index;
  const createOrUpdate = restfulResource.createOrUpdate;
  const destroy = restfulResource.destroy;

  return bindActionCreators(
    {
      index,
      createOrUpdate,
      destroy,
    },
    dispatch
  );
};

// @ts-expect-error: Argument of type '(props: EditableTableProps) => React.ReactElement' is not assignable to parameter of type 'ComponentType<Matching<{ index: () => (dispatch: any) => Promise<undefined>; createOrUpdate: (values: any) => (dispatch: any) => Promise<undefined>; destroy: (id: any) => (dispatch: any) => Promise<...>; }, EditableTableProps>>'.
export default connect(null, mapDispatchToProps)(EditableTable);
